import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { DataService } from '@barthauer/abc/core/data';
import { DxLoadIndicatorModule } from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { GroupSelectionComponent } from './group-selection/group-selection.component';
import { ObjectSelectionComponent } from './object-selection/object-selection.component';
import { _AbcButtonComponent, _AbcGridComponent, AbcTabPanelComponent } from '@barthauer/abc/ui-components';
import { ObjectsSetsModule } from '@barthauer/abc/ui-frameworks/objects-sets';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    MatIconModule,
    DxLoadIndicatorModule,
    _AbcGridComponent,
    _AbcButtonComponent,
    ObjectsSetsModule,
    AbcTabPanelComponent,
  ],
  declarations: [GroupSelectionComponent, ObjectSelectionComponent],
  exports: [GroupSelectionComponent, ObjectSelectionComponent],
  providers: [DataService, AbcConfigService, HttpClient],
})
export class AbcUiObjectSelectionModule {}
